export const iconFontAwesomeEmojiFaceSmile = (
	<i className="fa-solid fa-face-smile"></i>
);
